import React from 'react';
import type { GameMode } from '@business-game/shared';
import { SESSION_GAME_MODE_OPTIONS } from './sessionFormOptions';

type Props = {
  value: GameMode;
  onChange: (value: GameMode) => void;
  label?: string;
  compact?: boolean;
};

export const SessionGameModePicker: React.FC<Props> = ({
  value,
  onChange,
  label = 'Mode par défaut',
  compact = false,
}) => (
  <div>
    <label className="mb-2 block text-[11px] font-bold uppercase tracking-[0.08em] text-slate-400">{label}</label>
    <div className={`grid gap-2.5 ${compact ? 'grid-cols-2' : 'grid-cols-1 sm:grid-cols-2'}`}>
      {SESSION_GAME_MODE_OPTIONS.map((mode) => {
        const selected = value === mode.value;
        const isLeadlab = mode.value === 'leadlab';

        return (
          <button
            key={mode.value}
            type="button"
            onClick={() => onChange(mode.value)}
            className={[
              'flex items-center gap-3 rounded-[13px] border-[1.5px] px-3.5 text-left transition-all',
              compact ? 'py-2.5' : 'py-3.5',
              selected
                ? isLeadlab
                  ? 'border-emerald-500 bg-emerald-50/70 shadow-sm'
                  : 'border-indigo-500 bg-indigo-50/70 shadow-sm'
                : 'border-slate-200 bg-white hover:border-slate-300',
            ].join(' ')}
          >
            <span
              className={[
                'flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-[10px] text-[13px] font-bold',
                selected
                  ? isLeadlab
                    ? 'bg-emerald-600 text-white'
                    : 'bg-indigo-600 text-white'
                  : isLeadlab
                    ? 'bg-emerald-100 text-emerald-700'
                    : 'bg-indigo-100 text-indigo-700',
              ].join(' ')}
            >
              {isLeadlab ? 'LL' : 'TL'}
            </span>
            <span className="min-w-0 leading-tight">
              <span className={`block font-bold text-slate-900 ${compact ? 'text-sm' : 'text-base'}`}>{mode.label}</span>
              <span className="block text-[11.5px] text-slate-500">{mode.subtitle}</span>
            </span>
          </button>
        );
      })}
    </div>
  </div>
);
